<template>
    <section>
        <div v-if="loading" class="content content-centered">
            <pulse-loader></pulse-loader>
        </div>
        <div v-show="!loading" class="content">
            <div class="box">
                <div class="box-body">
                    <div class="row">
                        <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                            <div class="alert" :class="'alert-' + flashType">{{ flashMessage }}</div>
                        </div>
                    </div>
                    <div id="details" class="row">
                        <div class="col-sm-12 text-right">
                            <button class="btn btn-danger mr-5" type="button" @click="deleteschedulereportModal">Delete Schedule</button>
                        </div>
                        <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                           <div class="col-sm-12">
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.reportType)">
                                        <label>Report Type</label>
                                        <select v-model="schedulereport.reportType" required name="reportType" class="form-control" @change="getSelectiveStation">
                                            <option value="logbook">Vehicle Log Book</option>
                                            <option value="hcv_ms">Data HCV Mother Station</option>
                                            <option value="hcv_dbs">Data HCV DB Station</option>
                                            <option value="dsr">Daily Sales Report</option>
                                            <!-- <option value="consolidatedSales">Consolidated Sales Report</option> -->
                                        </select>
                                        <field-messages name="reportType" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Report Type is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.downloadType)">
                                        <label>Download Type</label>
                                        <select v-model="schedulereport.downloadType" required name="downloadType" class="form-control">
                                            <option value="PDF">PDF</option>
                                            <option value="XLSX">Excel</option>
                                        </select>
                                        <field-messages name="downloadType" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Download Type is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.reportFrequency)">
                                        <label>Report Frequency</label>
                                        <select v-model="schedulereport.reportFrequency" required name="reportFrequency" class="form-control" @change="validateReportFrequency">
                                            <option value="daily">Daily</option>
                                            <option value="weekly">Weekly</option>
                                        </select>
                                        <field-messages name="reportFrequency" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Report Frequency is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.status)">
                                        <label>Status</label>
                                        <select v-model="schedulereport.status" required name="status" class="form-control">
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <label for="scheduleStartDate">Schedule Start Date</label>
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.scheduleStartDate)">
                                        <date-picker  id="scheduleStartDate" v-model="schedulereport.scheduleStartDate" lang="en" name="scheduleStartDate" required input-class="form-control" width="100%" format="DD-MM-YYYY"></date-picker>
                                        <field-messages name="scheduleStartDate" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Start date is a required field</div>
                                        </field-messages>                                        
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <label for="scheduleEndDate">Schedule End Date</label>
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.scheduleEndDate)">
                                        <date-picker  id="scheduleEndDate" v-model="schedulereport.scheduleEndDate" lang="en" name="scheduleEndDate" required input-class="form-control" width="100%" format="DD-MM-YYYY"></date-picker>
                                        <field-messages name="scheduleEndDate" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">End date is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">                                    
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.scheduleDay)">
                                        <label>Schedule Day</label>
                                        <select v-model="schedulereport.scheduleDay"  name="scheduleDay" class="form-control" :disabled="disabledInput">
                                            <option value=0>Sunday</option>
                                            <option value=1>Monday</option>
                                            <option value=2>Tuesday</option>
                                            <option value=3>Wednesday</option>
                                            <option value=4>Thursday</option>
                                            <option value=5>Friday</option>
                                            <option value=6>Saturday</option>
                                        </select>
                                        <field-messages name="scheduleDay" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Schedule day is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.lastDays)">
                                        <label>Last Days</label>
                                        <select v-model="schedulereport.lastDays"  name="scheduleDay" class="form-control" >
                                            <option value=2>2 days</option>
                                            <option value=3>3 days</option>
                                            <option value=5>5 days</option>
                                            <option value=10>10 days</option>
                                        </select>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <label for="reportTime">Report Generation Time</label>
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.reportGenerationTime)">
                                        <vue-timepicker name="reportGenerationTime" required v-model="schedulereport.reportGenerationTime" style="width: 271px"></vue-timepicker>
                                        <field-messages name="reportGenerationTime" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Report Generation Time is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <legend class="col-md-12">Report Filter</legend>
                                <div class="col-sm-12">                         
                                    <div class="col-sm-6">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.region)">
                                            <label>Geographical Area</label>
                                            <select v-model="schedulereport.region" required name="region" class="form-control" @change="getSites">
                                                <option disabled>Select G.A</option>
                                                <option v-for="(item,index) in region_list" :key="index" :value="item.key">
                                                    {{item.value}}
                                                </option>
                                            </select>
                                            <field-messages name="region" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">G.A is a required field</div>
                                            </field-messages> 
                                        </validate>
                                    </div>
                                    <div class="col-sm-6" v-if="this.schedulereport.reportType != 'logbook'">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.station)">
                                            <label>Location</label>
                                            <select v-model="schedulereport.station" required name="station" class="form-control">
                                                <option disabled>Select Location</option>
                                                <option v-for="(item,index) in station_list" :key="index" :value="item.key">
                                                    {{item.value}}
                                                </option>
                                            </select>
                                            <field-messages name="station" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">Location is a required field</div> 
                                            </field-messages> 
                                        </validate>
                                    </div>
                                    <div class="col-sm-6" v-if="this.schedulereport.reportType == 'logbook'">
                                        <validate auto-label class="form-group" :class="fieldClassName(formstate.vehicleId)">
                                        <label>Vehicle</label>
                                        <select v-model="schedulereport.vehicleId"  name="vehicleId" class="form-control" :disabled="disabledVehicleInput">
                                            <option value="" disabled>Select Vehicle</option>
                                            <option v-for="(item,index) in vehicle_no" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                            <option value="all">All Vehicles</option>
                                        </select>
                                    </validate>                                        
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <legend class="col-md-12">Report Recipients</legend>
                                <div class="col-sm-12">
                                    <label for="emailTo" class="col-sm-3 control-label"> To </label>
                                    <div class="col-sm-5">
                                        <vue-select label="user" multiple :options="this.user_list" :searchable="true" language="en-US" v-model="schedulereport.emailTo" >
                                        </vue-select>
                                    </div>
                                    <br><br><br>
                                </div>                                
                                <div class="col-sm-12">
                                    <label for="emailCc" class="col-sm-3 control-label"> CC </label>
                                    <div class="col-sm-5">
                                        <vue-select label="user" multiple :options="this.user_list" :searchable="true" language="en-US" v-model="schedulereport.emailCc" >
                                        </vue-select>
                                    </div>
                                </div>
                            </div>
                        </vue-form>
                        <br><br>
                        <div class="col-sm-12 text-right">
                            <router-link :to="{ name: 'ReportSchedule' }">
                                <button class="mr-5 btn btn-default" type="button">Cancel</button>
                            </router-link>
                            <button class="mr-2 btn gradientbt" type="submit" @click="updateSchedule" :disabled="!(formstate.$dirty && formstate.$valid)">Update Schedule</button>
                        </div>
                    </div>                    
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { formService, eventBus , schedulereportService} from '../../../services'
import { EVENTS } from '../../../config'
import swal from 'sweetalert2'
export default {
    name: 'ReportScheduleDetails',
    data () {
        return {
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: EVENTS,
            formstate: {},
            station_list: {},
            region_list: {},
            user_list: {},
            disabledInput : false,
            disabledVehicleInput : false,
            boolean: false,
            emailTo: [],
            vehicle_no:{},
            emailCc:[],
            schedulereport : {
                emailTo: [],
                emailCc:[],
            },
        }
    },
    mounted : function() {
        this.getRegionList()
        this.getStationList()
        this.getUserList()
        this.getSchedule()
        // this.getVehicles()
    },
    methods: {
        fieldClassName: formService.fieldClassName,
       
        validateReportFrequency(){
            if (event.target.value =='weekly'){
                this.disabledInput = false
            }
            else{
                this.disabledInput = true
                delete this.schedulereport.scheduleDay 
            }
        },
        // getVehicles(){
        //     this.loading  = true;
        //     const params  = {}
        //     params.$limit = 0;
        //     let vehicleList = [];
        //     this.$vehicleDataRepository.list(params)
        //         .then((res)=> {
        //             this.loading  = false;
        //             if (res.data.docs) {
        //                 vehicleList =  res.data.docs.map((item)=> {
        //                     return {
        //                         key : item._id, 
        //                         value : item.regNo,
                                
        //                     }
        //                 })
                       
        //             }
        //             this.vehicle_no = vehicleList;
                    
        //         })
        //         .catch((error) => {
        //             this.loading  = false;
        //             console.error('vehicle.requestFunction-error:', error)
        //             this.$snotify.error('Get vehicle list failed', 'Error!')
        //         })  
        // },
        getSchedule () {
            return this.$schedulereportDataRepository.find(this.$route.params._id)
            .then((response) => {
                console.log("response",response)
                this.schedulereport = response.data;
                if (this.schedulereport.allVehicle == true){
                    this.schedulereport.vehicleId == 'all'
                }
                if(response.data.scheduleDay){
                    this.disabledInput = false;
                }
                else{
                   this.disabledInput = true; 
                }
                if(response.data.vehicleId || response.data.allVehicle ==    true){
                    this.disabledVehicleInput= false;
                }
                else{
                    this.disabledVehicleInput = true;
                }
            })
            .catch((error) => {
                console.error("error",error)
                this.$snotify.error('Report Schedule detail failed', 'Error!')
            })
        },
        updateSchedule () {
            this.loading = true;
            if (this.schedulereport.reportType == 'logbook'){
                delete this.schedulereport.station
            }
            if(this.schedulereport.vehicleId == 'all'){
                this.boolean = true,
                delete this.schedulereport.vehicleId
            }
            this.schedulereport = {
                ...this.schedulereport,
                allVehicle : this.boolean
            }
            return schedulereportService.updateSchedule(this.schedulereport)
            .then((response) => {
                this.loading = false
                this.flash = false
                this.$snotify.success('Schedule updated!', 'Success!')
                this.$router.push('/report_settings')
            })
            .catch(error => {
                this.loading = false
                this.$snotify.error('Schedule update failed!Try Again', 'Error!')
                if (error.data.message.includes('must be one of')) {
                    this.flash = true
                    this.flashType = 'error'
                    this.flashMessage = 'Schedule update failed.Please try again!'
                }
                this.$router.push('/report_settings')
            })
        },
        deleteschedulereportModal () {
            swal({
                title: 'Are you sure?',
                text: 'This will permanently delete this Schedule!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            }).then((result) => {
                if (result.value) {
                    this.deleteSchedule()
                }
            })
        },
        deleteSchedule () {
            this.loading = true
            return this.$schedulereportDataRepository.deleteOne(this.schedulereport._id)
            .then((response) => {
                this.loading = false;
                return swal(
                    'Deleted!',
                    'Schedule has been deleted.',
                    'success'
                )
            })
            .then((response) => {
                this.loading = false;
                this.$router.push('/report_settings')
            })
            .catch((error) => {
                this.loading = false;
                this.$snotify.error('Delete Schedule failed', 'Error!')
            })
        },
        fieldClassName: function (field) {
            if(!field) {
                return '';
            }
            if((field.$touched || field.$submitted) && field.$valid) {
                return 'has-success';
            }
            if((field.$touched || field.$submitted) && field.$invalid) {
                return 'has-danger';
            }
        },
        fieldClassName: formService.fieldClassName,
        getRegionList() {
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            let regionlist = [];
            this.$regionDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        regionlist =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.name
                            }
                        })
                    }
                    this.region_list = regionlist;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('Region.requestFunction-error:', error)
                    this.$snotify.error('Get region list failed', 'Error!')
                })
        },
        getSelectiveStation(e){
            const params  = {}
            params.$limit = 0;
            if(this.schedulereport.region){
                params.region = this.schedulereport.region;
            }
            if(e.target.value == "hcv_ms"){
                params.siteType = "MS"
            }
            if(e.target.value == "hcv_dbs" || e.target.value == "dsr"){
                params.siteType = "DBS"
            }
            let stationlist = [];
            this.$siteDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        stationlist =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.siteName
                            }
                        })
                    }
                    this.station_list = stationlist;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('Site.requestFunction-error:', error)
                    this.$snotify.error('Get station list failed', 'Error!')
                })
        },
        getSites(e){
            const params  = {}
            params.$limit = 0;
            this.schedulereport.station ='';
            params.region = e.target.value;
            if(this.schedulereport.reportType == 'hcv_ms'){
                params.siteType = 'MS'
            }
            if(this.schedulereport.reportType == 'hcv_dbs' || e.target.value == "dsr"){
                params.siteType = 'DBS'
            }
            let stationlist = [];
            this.$siteDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        stationlist =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.siteName
                            }
                        })
                    }
                    this.station_list = stationlist;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('Site.requestFunction-error:', error)
                    this.$snotify.error('Get station list failed', 'Error!')
                })
            let vehicleList = [];
            const params1 = {}
            params1.$limit = 0;
            params1.region = e.target.value;
            this.$vehicleDataRepository.list(params1)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        vehicleList =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.regNo,
                                
                            }
                        })
                       
                    }
                    this.vehicle_no = vehicleList;
                    
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('vehicle.requestFunction-error:', error)
                    this.$snotify.error('Get vehicle list failed', 'Error!')
                })

        },
        getStationList(){
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            let stationlist = [];
            this.$siteDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        stationlist =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.siteName
                            }
                        })
                    }
                    this.station_list = stationlist;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('Site.requestFunction-error:', error)
                    this.$snotify.error('Get station list failed', 'Error!')
                })
        },
        getUserList(){
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            let userlist = [];
            this.$userRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        userlist =  res.data.docs;
                    }
                    this.user_list = userlist.map(item => {
                        return { 
                            value : item.email,
                            user: `${item.firstName} ${item.lastName}`
                        }
                    }) 
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('User.requestFunction-error:', error)
                    this.$snotify.error('Get user list failed', 'Error!')
                })
        },
    }
}
</script>
<style scoped>
    .required-field > label::after  {
        content: '*';
        color: red;
        margin-left: 0.25rem;
    }
    .form-control-feedback {
        font-weight: 100;
        color: red;
        position: initial;
        text-align: left;
        height: auto;
        width: auto;
    }
    .has-danger {
        color: red
    }
    .gradientbt{
        background: #0F6940;
        color: white
    }
    .box-body {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
    }
    
</style> 


// WEBPACK FOOTER //
// ReportScheduleDetails.vue?7bee9144